import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../../Utils/AxiosInstance";
import { revertAll } from "../../ResetStateAction";

const initialState = {
  Roles: [],
  RolesERP: [],
  ParentRoles: [],
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  message1: null,
  status1: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error1: null,
  IsLogin: true,
};
// export const fetchRoles = createAsyncThunk("/Roles", async () => {
//   const response = await axiosInstanceAuth.get(`/Roles`);

//   return response.data;
// });
export const fetchRoles = createAsyncThunk("/Roles", async moduleName => {
  const response = await axiosInstanceAuth.get(`/Roles`, {
    params: { Module: moduleName }, // sending query parameter
  });
  return response.data;
});

export const fetchRolesERP = createAsyncThunk("/RolesERP", async moduleName => {
  const response = await axiosInstanceAuth.get(`/Roles`, {
    params: { Module: moduleName }, // sending query parameter
  });
  return response.data;
});

export const fetchParentRoles = createAsyncThunk("/Screens/ParentPopulate", async () => {
  const response = await axiosInstanceAuth.get(`/Screens/ParentPopulate`);

  return response.data;
});

const RolesSlice = createSlice({
  name: "Roles",
  initialState,
  reducers: {
    RolesAdded: {
      reducer(state, action) {
        state.Roles?.push(action.payload);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchRoles.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.Roles = action.payload.Data;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchRolesERP.pending, state => {
        state.status1 = "loading";
      })
      .addCase(fetchRolesERP.fulfilled, (state, action) => {
        state.status1 = "succeeded";
        state.message1 = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.RolesERP = action.payload.Data;
      })
      .addCase(fetchRolesERP.rejected, (state, action) => {
        state.error1 = action.error.message;
        state.status1 = "failed";
      })
      .addCase(fetchParentRoles.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchParentRoles.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.ParentRoles = action.payload.Data;
      })
      .addCase(fetchParentRoles.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const getRolesDetails = state => state.Roles;

export const { RolesAdded } = RolesSlice.actions;

export default RolesSlice.reducer;
